import { Helmet } from 'react-helmet-async';
import { useStoreInfo } from '@/lib/store';

export function ReturnPolicyPage() {
  const { storeInfo } = useStoreInfo();
  const pageTitle = `Return Policy${storeInfo?.site_name ? ` - ${storeInfo.site_name}` : ''}`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="Our return policy" />
      </Helmet>

      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">Return Policy</h1>
            
            <div className="prose prose-lg dark:prose-invert">
              <p>
                At {storeInfo?.site_name || 'our store'}, we do not accept returns or exchanges for any products purchased.
              </p>

              <h2>No Returns Policy</h2>
              <p>
                Due to the nature of our products and to ensure food safety and quality:
              </p>
              <ul>
                <li>All sales are final</li>
                <li>We do not accept returns</li>
                <li>We do not offer refunds once an order is placed</li>
                <li>We do not offer exchanges</li>
              </ul>

              <h2>Order Verification</h2>
              <p>
                Please carefully review your order before completing your purchase. Verify:
              </p>
              <ul>
                <li>Product selections</li>
                <li>Quantities</li>
                <li>Delivery address</li>
                <li>Contact information</li>
              </ul>

              <h2>Quality Commitment</h2>
              <p>
                While we don't accept returns, we are committed to providing high-quality products. All our items are carefully prepared and packaged to ensure quality upon delivery.
              </p>

              <h2>Damaged or Incorrect Items</h2>
              <p>
                In the rare case that you receive a damaged item or an incorrect order, please contact us immediately at{' '}
                {storeInfo?.contact_email || 'our contact email'}. We will assess the situation and work to resolve any issues.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have any questions about our no-return policy, please contact our customer service team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}